module.exports = __webpack_public_path__ + "img/00—02—Password recovery—IB2.9a219ba9.jpg";